(() => {
  const breakpoint = window.matchMedia("(max-width: 749px)");

  const initialize = (scope) => {
    scope.querySelectorAll("[data-mobile-sticky-purchase]").forEach((bar) => {
      if (bar.dataset.initialized === "true") return;

      const productSection = bar.closest("[data-main-product-enhancements]");
      const purchaseButton = productSection?.querySelector(
        '[data-type="add-to-cart-form"] button[name="add"]'
      );
      const stickyButton = bar.querySelector(
        "[data-mobile-sticky-purchase-button]"
      );
      const stickyLabel = bar.querySelector(
        "[data-mobile-sticky-purchase-label]"
      );

      if (!productSection || !purchaseButton || !stickyButton || !stickyLabel) {
        return;
      }

      bar.dataset.initialized = "true";

      const updateVisibility = () => {
        const hasPreviewToolbar =
          breakpoint.matches &&
          window.Shopify?.theme?.role === "unpublished" &&
          document.getElementById("PBarNextFrame");
        bar.style.bottom = hasPreviewToolbar ? "64px" : "";

        const sectionRect = productSection.getBoundingClientRect();
        const buttonRect = purchaseButton.getBoundingClientRect();
        const productSectionVisible =
          sectionRect.bottom > 0 && sectionRect.top < window.innerHeight;
        const purchaseButtonVisible =
          buttonRect.bottom > 0 && buttonRect.top < window.innerHeight;
        bar.hidden = !(
          breakpoint.matches &&
          productSectionVisible &&
          !purchaseButtonVisible
        );
      };

      const syncPurchaseState = () => {
        stickyButton.disabled = purchaseButton.disabled;
        const label = purchaseButton.querySelector("span")?.textContent.trim();
        if (label) stickyLabel.textContent = label;
      };

      const onBreakpointChange = () => updateVisibility();
      if (breakpoint.addEventListener) {
        breakpoint.addEventListener("change", onBreakpointChange);
      } else {
        breakpoint.addListener(onBreakpointChange);
      }

      stickyButton.addEventListener("click", () => {
        syncPurchaseState();
        if (!purchaseButton.disabled) purchaseButton.click();
      });

      productSection.addEventListener("change", syncPurchaseState);
      new MutationObserver(syncPurchaseState).observe(purchaseButton, {
        attributes: true,
        childList: true,
        subtree: true,
      });
      window.addEventListener("scroll", updateVisibility, { passive: true });
      window.addEventListener("resize", updateVisibility);
      window.addEventListener("load", updateVisibility, { once: true });
      syncPurchaseState();
      updateVisibility();
    });
  };

  const initializeDocument = () => initialize(document);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeDocument, {
      once: true,
    });
  } else {
    initializeDocument();
  }
  document.addEventListener("shopify:section:load", (event) =>
    initialize(event.target)
  );
})();
